import { render, staticRenderFns } from "./socketInfo.vue?vue&type=template&id=01abe7a5&scoped=true&"
import script from "./socketInfo.vue?vue&type=script&lang=js&"
export * from "./socketInfo.vue?vue&type=script&lang=js&"
import style0 from "./socketInfo.vue?vue&type=style&index=0&id=01abe7a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01abe7a5",
  null
  
)

export default component.exports